import React, { Component } from 'react'
import css from './styleOutline.module.css'

export default class Textarea extends Component {
    state = {
        stringLengthLimit: '',
        error: null
    }

    setError(error) {
        this.setState({
            error
        })
    }

    removeError() {
        this.setState({
            error: null
        })
    }
    
    componentDidMount() {   
        const { value, defaultValue } = this.props
        let length = value ? value.length : (defaultValue ? defaultValue.length : 0)
        this.setSizeLenght(length)

        if(this.props.onChangeDOM) {
            this.refs.textarea.addEventListener('change', (event) => {
                this.props.onChangeDOM(event)
            })
        }
    }

    handleChange(e) {
        if(this.props.onChange)
        this.props.onChange(e)

        this.setSizeLenght(e.target.value.length)
    }

    setSizeLenght(size) {
        let maxLengthStringReplaced = null
        if(this.props.maxLengthString && this.props.maxLength) {
            maxLengthStringReplaced = this.props.maxLengthString.replace('{lenght}', size).replace('{limit}', this.props.maxLength)
            this.setState({
                stringLengthLimit: maxLengthStringReplaced
            })
        }
    }

    render() {
        const {
                style,
                label,
                TrailingIcon,
                className,
                maxLength,
                hasError,
                maxLengthString,
                onChange,
                onChangeDOM,
                height,
                ...props } = this.props

        const classes = [className]

        classes.push(css.box)

        if(TrailingIcon)
        classes.push(css.withTrailingIcon)

        const textareaStyle = {}
        if(height)
        textareaStyle.height = height

        return (
            <label className={classes.join(' ')} style={{ ...style }}>
                <textarea
                    {...props}
                    ref='textarea'
                    placeholder=" "
                    className={[css.formControl, this.state.error !== null ? css.error : null, hasError ? css.error : null].join(' ')}
                    maxLength={maxLength}
                    onChange={e => this.handleChange(e)}
                    style={textareaStyle}
                    onKeyPress={() => {
                        this.removeError()
                    }} />
                
                {label && (
                    <span>{label}</span>
                )}
                
                {TrailingIcon && (
                    <span className={css.trailingIcon}>
                        <TrailingIcon />
                    </span>
                )}

                {this.state.stringLengthLimit && (
                    <span className={css.maxLength}>
                        {this.state.stringLengthLimit}
                    </span>
                )}

                {this.state.error && (
                    <span className={css.errorMessage}>{this.state.error}</span>
                )}
            </label>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/atoms/Form/Textarea.js